import {Grid, Paper, Typography} from "@mui/material";
import * as React from "react";

const DragDropOption = ({optionId, handleDrag, option}) => {
    return (
        <Paper elevation={3}
               draggable={true}
               id={optionId}
               onDragOver={(ev) => ev.preventDefault()}
               onDragStart={handleDrag}
               sx={{my: 1, p: 1, cursor: "pointer", touchAction: "none"}}
        >
            {option["img"] ?
                (
                    <Grid container justifyContent="center" alignItems="center" sx={{my: 2}}>
                        <img src={option["img"]}
                             style={{maxHeight: 100, maxWidth: "100%"}}
                             alt="Question"
                             draggable={false}/>
                    </Grid>
                ) : (
                    <></>
                )
            }
            <Typography>{option["content"]}</Typography>
        </Paper>
    );
};

export default DragDropOption;